// utils/encrypt.js (React)
import CryptoJS from "crypto-js";

const _K = process.env.REACT_APP_ENCRYPTION_KEY;

export function encryptData(data) {
  if (!_K) return "";
  return CryptoJS.AES.encrypt(JSON.stringify(data), _K).toString();
}